
import { Vue, Component } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
  private _header = "Header";

  get header() {
    return this._header;
  }
  set header(value: string) {
    this._header = value;
  }

  close() {
    this.$emit("close");
  }
}
